import { render, staticRenderFns } from "./monthstock.vue?vue&type=template&id=34aba5d9&scoped=true&"
import script from "./monthstock.vue?vue&type=script&lang=js&"
export * from "./monthstock.vue?vue&type=script&lang=js&"
import style0 from "./monthstock.vue?vue&type=style&index=0&id=34aba5d9&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34aba5d9",
  null
  
)

export default component.exports